import { errorNotification } from "../../layout/components/Notifications/notifications";
import { useEffect, useState } from "react";
import { ArrowDownIcon, DownloadIcon, VerticalLayoutIcon, HorizontalLayoutIcon } from "../../../assets/icons/common/common-icons";
import { PrimaryButtonWithIcon, SecondaryButtonWithIcon } from "../../../common/components/buttons/NewButtons.styles";
import { ActionButtonsWrapper, CheckboxWrapper, DataBoxInputElement, DataBoxInputLabel, DataBoxInputWrapper, FormContentWrapper, GroupedByWrapper, StyledCheckbox } from "./Reports.styles";
import { LoadingOutlined } from '@ant-design/icons';
import { StyledSelect } from "../../user/components/Profile.styles";
import { Select, Radio, Space } from "antd";
import { useStore } from "../../app/data/root.store";
import { observer } from "mobx-react";
import { EntitiesChart } from "../../entities/components/EntitiesChart/EntitiesChart";
import { downloadImage } from "../../entities/utils/graphUtils";
import { ReactFlowProvider } from "@xyflow/react";
import { ReactComponent as BlackDownloadIcon } from "./icons/black-download-icon.svg";

export const EntityStructureReport = observer(({ isMobileAppView }) => {

    const { metadataStore, entitiesStore } = useStore();
    const [isLoading, setIsLoading] = useState(false);
    const [holdingEntities, setHoldingEntities] = useState([]);
    const [holdingEntitiesInputValue, setHoldingEntitiesInputValue] = useState('Include all entities');
    const [isAllEntitiesChecked, setIsAllEntitiesChecked] = useState(true);
    const [data, setData] = useState(null);
    const [pageLayout, setPageLayout] = useState('vertical');

    useEffect(() => {
        if (metadataStore.isLoaded) {
            setHoldingEntities(metadataStore.beneficiaries.sort((a, b) => a.name.localeCompare(b.name)).map(entity => ({ ...entity, checked: true })));
        }

    }, [metadataStore.isLoaded, metadataStore.beneficiaries]);

    useEffect(() => {
        const imageDownloadFunction = async () => {
            setIsLoading(true);
            setTimeout(() => {
                downloadImage(data.nodes);
                setTimeout(() => {
                    setData(null);
                    setIsLoading(false);
                }, 0);
            }, 1000);
        }

        if (data) {
            imageDownloadFunction();
        }

    }, [data]);

    const { Option } = Select;
    
    const download = async () => {
        setIsLoading(true);
        try {
            const roots = holdingEntities.length === 0 ? null : holdingEntities.filter(entity => entity.checked === true).map(entity => entity.id);
            const { nodes, edges } = await entitiesStore.getEntitiesForReport(roots);
            setData({ nodes, edges });
        } catch (error) {
            errorNotification(error);
        } finally {
            setIsLoading(false);
        }
    };

    const downloadSample = () => {
        console.log('downloadSample');
    };

    const holdingEntitiesNamesValue = () => {
        const checkedEntities = holdingEntities.filter(entity => entity.checked === true)
        const names = checkedEntities.map(entity => entity.name)
        setHoldingEntitiesInputValue(names.join(', '))
    }

    const handleAllEntitiesDeselected = (e) => {
        if (holdingEntities.every(entity => entity.checked === false)) {
            handleSelectAll(e);
        }
    }

    const handleSelectAll = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const checkedEntities = holdingEntities
        if (isAllEntitiesChecked) {
            setIsAllEntitiesChecked(false)
            setHoldingEntitiesInputValue('Please choose entities')
            checkedEntities.forEach((entity) => { entity.checked = false })

        } else if (!isAllEntitiesChecked) {
            setIsAllEntitiesChecked(true);
            setHoldingEntitiesInputValue('Include all entities')
            checkedEntities.forEach((entity) => { entity.checked = true })
        }

        setHoldingEntities([...checkedEntities])
    }
    const handleEntitiesSelection = (e, entityName, entityChecked) => {
        e.stopPropagation();
        e.preventDefault();

        const relevantEntityIndex = holdingEntities.findIndex(entity => entity.name === entityName);
        holdingEntities[relevantEntityIndex] = { ...holdingEntities[relevantEntityIndex], checked: !entityChecked };
        setHoldingEntities(holdingEntities);
        if (holdingEntities.every(entity => entity.checked === false)) {
            setHoldingEntitiesInputValue('Please choose at least one entity');
        } else if (holdingEntities.every(entity => entity.checked === true)) {
            setIsAllEntitiesChecked(true);
            setHoldingEntitiesInputValue('Include all entities')
        } else {
            holdingEntitiesNamesValue();
            if (isAllEntitiesChecked) setIsAllEntitiesChecked(false)
        }
    }

    return (
        <>
            <FormContentWrapper>
                <DataBoxInputWrapper>
                    <DataBoxInputLabel fontSize='14px'>
                        Holding entity
                    </DataBoxInputLabel>
                    <DataBoxInputElement>
                        <StyledSelect name='holdingEntity' onBlur={handleAllEntitiesDeselected}
                            value={holdingEntitiesInputValue}
                            suffixIcon={<ArrowDownIcon />}
                            getPopupContainer={() => document.getElementById('reportsPage')}
                        >
                            <Option key='all-entities' value='all-entities'>
                                <CheckboxWrapper width={'100%'} onClick={(e) => handleSelectAll(e)}>
                                    <StyledCheckbox type="checkbox" name='select all' checked={isAllEntitiesChecked}>Include all entities</StyledCheckbox>
                                </CheckboxWrapper>
                            </Option>
                            {holdingEntities.map((entity, index) => (
                                <Option key={entity.name} value={index}>
                                    <CheckboxWrapper width={'100%'} onClick={(e) => handleEntitiesSelection(e, entity.name, entity.checked)}>
                                        <StyledCheckbox type="checkbox" checked={entity.checked}>{entity.name}</StyledCheckbox>
                                    </CheckboxWrapper>
                                </Option>))
                            }
                        </StyledSelect>
                    </DataBoxInputElement>
                </DataBoxInputWrapper>

                <GroupedByWrapper>
                    Page layout:
                    <Radio.Group onChange={(e) => setPageLayout(e.target.value)} value={pageLayout}>
                        <Space direction='vertical'>
                            <Radio value='vertical' style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '-6px' }}>
                                    <VerticalLayoutIcon style={{ width: '20px', height: '20px' }} />
                                    Vertical
                                </div>
                            </Radio>
                            <Radio value='horizontal' style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '-6px' }}>
                                    <HorizontalLayoutIcon style={{ width: '20px', height: '20px' }} />
                                    Horizontal
                                </div>
                            </Radio>
                        </Space>
                    </Radio.Group>
                </GroupedByWrapper>
            </FormContentWrapper>
            <ActionButtonsWrapper>
                <PrimaryButtonWithIcon style={{ width: '202px', height: '38px' }} onClick={download} isProcessing={isLoading}>
                    {isLoading ? <LoadingOutlined /> : <div style={{ display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}><DownloadIcon />Download structure</div>}
                </PrimaryButtonWithIcon>
                <SecondaryButtonWithIcon style={{ height: '38px' }} onClick={downloadSample}>
                    <BlackDownloadIcon /> Download sample
                </SecondaryButtonWithIcon>
            </ActionButtonsWrapper>
            {
                data &&
                <div style={{ position: 'fixed', top: '-100vh', left: '-100vw', width: '100vw', height: '100vh'}}>
                    <ReactFlowProvider>
                        <EntitiesChart
                            nodes={data.nodes}
                            edges={data.edges}
                        />
                    </ReactFlowProvider>
                </div>
            }
        </>
    )
});